import { useComposedRefs } from '@radix-ui/react-compose-refs'

import { AppSettingsPageIsOverflowingTopStyle } from 'features/AppSettings/AppSettingsPage.css'
import { useOverflowY } from 'features/views/ListView/hooks/useOverflowY'

export function useAppSettingsPageState() {
    const { targetRef, scrollAreaRef } = useOverflowY({
        topClassName: AppSettingsPageIsOverflowingTopStyle,
    })

    const wrapperRef = useComposedRefs<HTMLDivElement>(
        targetRef as React.MutableRefObject<HTMLDivElement>,
        scrollAreaRef
    )

    return {
        wrapperRef,
    }
}
